import collapse from './_collapse.js';
import lazyload from './_lazyload.js';
import tab from './_tab.js';
import shifter from './_shifter.js';
import header from './_header.js';


export default {
	collapse,
    shifter,
	lazyload,
	tab,
	header,
};